module.exports = __webpack_public_path__ + "static/media/Ch4-dark.99fb131f.jpg";